import { fetchWrapper } from "api";

export const getServerTime = () => fetchWrapper("/misc/serverTime");
export const postLogError = body => fetchWrapper("POST", "/misc/logError", body, {});
export const getGlobalConfig = () =>
  fetchWrapper(
    "/misc/globalConfig" +
      (process.env.REACT_APP_SUB_MODE ? "?env=" + process.env.REACT_APP_SUB_MODE.toLowerCase() : "")
  );
